import React, { useEffect, useState } from 'react';
import { StyleSheet, View, ActivityIndicator } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { tenantActions } from '../openFlowRedux/tenant.actions';
import BackGroundGenerator from '../../LandingPages/common/BackGroundGenerator';
import NoticeBox from '../../../../openbrix-design-system/ui/molecules/openflowHome/NoticeBox';

const Notice = (props) => {
  const dispatch = useDispatch();
  const [moveOutData, setMoveOutData] = useState(null);
  const [loading, setLoading] = useState(true);

  const reduxMoveOutData = useSelector((state) => state?.tenant?.moveOutData);
  const flowId = props?.route?.params?.id || (typeof window !== 'undefined' && window.location?.pathname?.split('/')?.pop());

  useEffect(() => {
    if (flowId) {
      setLoading(true);
      dispatch(
        tenantActions.getMoveOutData(flowId, (data) => {
          setMoveOutData(data);
          setLoading(false);
        })
      );
    } else {
      setLoading(false);
    }
  }, [flowId]);

  useEffect(() => {
    if (reduxMoveOutData && !moveOutData) {
      setMoveOutData(reduxMoveOutData);
    }
  }, [reduxMoveOutData]);

  const notice = moveOutData?.open_flow_move_out_notice || reduxMoveOutData?.open_flow_move_out_notice || moveOutData?.data?.open_flow_move_out_notice || reduxMoveOutData?.data?.open_flow_move_out_notice;
  const isCompleted = notice?.notice_received_completed && notice?.notice_served_completed;
  const buttonTextVal = notice ? (isCompleted ? 1 : 4) : 0;

  return (
    <BackGroundGenerator
      props={props}
      isTLYF
      isOpenflowContainer
      openFlowData={{
        title: 'Notice',
        desc: '',
        buttonText: buttonTextVal,
        message: '',
        listIcon: 'msg',
        iconColor: '#A070C4',
      }}
    >
      <View style={styles.container}>
        {loading && !moveOutData ? (
          <ActivityIndicator size="large" color="#1FA6B2" style={{ marginTop: 40 }} />
        ) : (
          <NoticeBox data={moveOutData || reduxMoveOutData} />
        )}
      </View>
    </BackGroundGenerator>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
  },
});

export default Notice;
